import React from 'react';
import { ClipboardCheck } from 'lucide-react';
import { ILMSModal } from './ILMSModal';
import { ILMSButton } from './ILMSButton';

interface PendingApprovalsModalProps {
  open: boolean;
  count: number;
  onClose: () => void;
  onReview: () => void;
}

/**
 * Shown once after login (dismissed for the rest of the SPA session, same
 * as ChangePasswordModal's own one-shot pattern) when the signed-in user
 * can approve Milk and at least one Milk Session or Milk Sale is sitting
 * Pending — on request, so an Admin doesn't have to stumble onto the
 * approval queue on their own. Count comes from the Dashboard KPIs query
 * AppShell already shares with the Dashboard page itself (sessions + sales
 * combined), not a separate fetch.
 */
export function PendingApprovalsModal({ open, count, onClose, onReview }: PendingApprovalsModalProps) {
  return (
    <ILMSModal
      open={open}
      onClose={onClose}
      title="Milk entries awaiting approval"
      size="sm"
      footer={
        <>
          <ILMSButton variant="ghost" onClick={onClose}>
            Later
          </ILMSButton>
          <ILMSButton icon={<ClipboardCheck />} onClick={onReview}>
            Review now
          </ILMSButton>
        </>
      }
    >
      <p className="text-body text-ink-700">
        {count === 1
          ? 'There is 1 milk session or sale waiting for your approval.'
          : `There are ${count} milk sessions/sales waiting for your approval.`}{' '}
        Nothing it contains counts toward production totals or reports until it's checked and approved.
      </p>
    </ILMSModal>
  );
}
